import React, { useEffect, useState, useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import CourseDetailsPageHeader from "../../CourseDetailsPageHeader/CourseDetailsPageHeader";
import FourthFormContent from "../FourthFormContent/FourthFormContent";
import LoadingSpinner from "../../../../shared/components/LoadingSpinner/LoadingSpinner";

const FourthFormPageDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const outletContext = useOutletContext() || {};
  const setContentLoaded = useMemo(
    () => outletContext.setContentLoaded || (() => {}),
    [outletContext.setContentLoaded]
  );

  useEffect(() => {
    // Simulate loading for 500ms (adjust as needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
      // Signal that this page is loaded.
      setContentLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [setContentLoaded]);

  if (isLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="courseMaterialsPage">
      <CourseDetailsPageHeader title="SCA Fourth Form Courses Materials" />
      <FourthFormContent />
    </div>
  );
};

export default FourthFormPageDetails;
